import { exportsModule } from '@cian/mf-registry/browser';
import { createApplicationState } from '../services/applicationState';
import { createApplicationContext } from '../services/applicationContext';
import { createCustomElementConstructor } from './createCustomElementConstructor';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/v1/get-footer-microfrontend/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
  });
}
